import React from 'react';

import DLIOS from '@/assets/svg/Download_iOS.svg';
import DLAndroid from '@/assets/svg/Download_Android.svg';
import { useTranslation } from 'react-i18next';

interface DownloadAppProps {
  iOSLink?: string;
  androidLink?: string;
}

const DownloadApp: React.FC<DownloadAppProps> = ({ iOSLink, androidLink }) => {
  const { t } = useTranslation();

  return (
    <div className="my-20 lg:my-[200px] lg:max-w-main lg:mx-auto">
      <p className="mb-20 text-4xl md:text-4xl lg:text-6xl xl:text-h1 font-heading">
        <span className="text-primaryLighter">{t('download')}</span>{' '}
        {t('theAppNow')}
      </p>
      <div className="flex flex-col lg:flex-row">
        {!!iOSLink && (
          <a href={iOSLink} target="_blank" rel="noreferrer">
            <DLIOS className="w-max h-24 mr-0 lg:mr-11 mb-4 lg:mb-0" />
          </a>
        )}
        {!!androidLink && (
          <a href={androidLink} target="_blank" rel="noreferrer">
            <DLAndroid className="w-max h-24" />
          </a>
        )}
      </div>
    </div>
  );
};

export default DownloadApp;
